import { createBrowserHistory } from 'history';
import withDependencies from '@factorin/container.macro';


let historyHandle = null;

export const history = withDependencies(config => {
    historyHandle = historyHandle || createBrowserHistory({
        basename: config.basePath,
    });
    return historyHandle;
});
